import axios from 'axios'

import config from '../../config'

const deleteNotificationGroup = (params = {}) => {
  const { airportId, id } = params

  const url = `${config.baseUrl}/${airportId}/NotificationGroups/${id}`
  return axios.delete(url)
}

export default deleteNotificationGroup
